import { useQuery } from '@tanstack/react-query';
import { listAdminCompanies, type CompanyMembersScope } from './company-api';

export function useCompanyScopeName(scope: CompanyMembersScope) {
  const companiesQuery = useQuery({
    enabled: scope.type === 'targeted',
    queryFn: () => listAdminCompanies(),
    queryKey: ['admin', 'companies', 'directory'],
  });
  return scope.type === 'targeted'
    ? companiesQuery.data?.data.find((company) => company.id === scope.companyId)?.name
    : undefined;
}
